import React, { useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';

import { getFaqItemsFromMessages } from '../../../data/faq';

const SupportFaq = () => {
  const intl = useIntl();
  const faqItems = useMemo(
    () => getFaqItemsFromMessages(intl.messages),
    [intl.messages]
  );
  const [openItemId, setOpenItemId] = useState<string | null>(null);

  useEffect(() => {
    setOpenItemId((currentId) => currentId ?? faqItems[0]?.id ?? null);
  }, [faqItems]);

  const handleToggle = (itemId: string) => {
    setOpenItemId((currentId) => (currentId === itemId ? null : itemId));
  };

  return (
    <div className="support-faq" role="list">
      {faqItems.map((item) => {
        const isOpen = openItemId === item.id;

        return (
          <article
            key={item.id}
            className={`support-faq__item${isOpen ? ' support-faq__item--open' : ''}`}
            role="listitem"
          >
            <button
              type="button"
              className="support-faq__trigger"
              aria-expanded={isOpen}
              onClick={() => handleToggle(item.id)}
            >
              <span className="support-faq__question">
                {intl.formatMessage({ id: item.questionId })}
              </span>
              <span className="support-faq__toggle" aria-hidden="true" />
            </button>
            {isOpen && (
              <div className="support-faq__body">
                <p className="support-faq__answer">
                  {intl.formatMessage({ id: item.answerId })}
                </p>
              </div>
            )}
          </article>
        );
      })}
    </div>
  );
};

export default SupportFaq;
